import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1980638c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = {
  class: "footer"
};
const _hoisted_3 = ["src"];

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "横滑切换上下首哦", -1));

const _hoisted_5 = {
  class: "footerRight"
};
const _hoisted_6 = ["src", "onloadedmetadata"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_MusicDetails = _resolveComponent("MusicDetails");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "footerLeft",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.updateIsPopups(true))
  }, [_createElementVNode("img", {
    src: _ctx.playList[_ctx.playListIndex].al.picUrl,
    alt: ""
  }, null, 8, _hoisted_3), _createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(_ctx.playList[_ctx.playListIndex].name), 1), _hoisted_4])]), _createElementVNode("div", _hoisted_5, [_ctx.isbtnShow ? (_openBlock(), _createBlock(_component_van_icon, {
    key: 0,
    name: "play-circle-o",
    size: "30",
    onClick: $options.play
  }, null, 8, ["onClick"])) : (_openBlock(), _createBlock(_component_van_icon, {
    key: 1,
    name: "pause-circle-o",
    size: "30",
    onClick: $options.play
  }, null, 8, ["onClick"])), _createVNode(_component_van_icon, {
    name: "wap-nav",
    size: "30"
  })]), _createElementVNode("audio", {
    ref: "audio",
    src: `https://music.163.com/song/media/outer/url?id=${_ctx.playList[_ctx.playListIndex].id}.mp3`,
    onloadedmetadata: $options.myFunction
  }, null, 8, _hoisted_6), _createVNode(_component_van_popup, {
    show: _ctx.isPopups,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => _ctx.isPopups = $event),
    position: "bottom",
    style: {
      height: '100%',
      width: '100%'
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_MusicDetails, {
      musicList: _ctx.playList[_ctx.playListIndex],
      play: $options.play,
      isbtnShow: _ctx.isbtnShow,
      addDuration: $options.addDuration
    }, null, 8, ["musicList", "play", "isbtnShow", "addDuration"])]),
    _: 1
  }, 8, ["show"])])]);
}